import { useEffect, useState } from "react";
import { fetchProducts, fetchSold } from "@/lib/products";
import { pinToId } from "@/lib/store";
import { TradeBanner } from "@/components/site/TradeBanner";
import { TradeBonusBadge } from "@/components/site/TradeBonusBadge";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { TopCarousel } from "@/components/site/TopCarousel";
import { Marquee } from "@/components/site/Marquee";
import { FeaturedOffer } from "@/components/site/FeaturedOffer";
import { Catalog } from "@/components/site/Catalog";
import { SoldShowcase } from "@/components/site/SoldShowcase";
import { WhyBuy } from "@/components/site/WhyBuy";
import { OrderSection } from "@/components/site/OrderSection";
import { Contact } from "@/components/site/Contact";
import { AlertsSection } from "@/components/site/AlertsSection";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sold, setSold] = useState([]);

  useEffect(() => {
    fetchProducts()
      .then(setProducts)
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
    fetchSold()
      .then(setSold)
      .catch(() => setSold([]));
  }, []);

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (!hash) return undefined;
    return pinToId(hash);
  }, []);

  return (
    <SmoothScroll>
      <div className="grain min-h-screen bg-[#09090b] text-white">
        <Header />
        <main>
          <TopCarousel products={products} />
          <Hero count={products.length} compact={products.some((p) => (p?.category || "iphone") === "iphone")} />
          <TradeBonusBadge />
          <FeaturedOffer product={products.find((p) => p?.featured)} />
          <Marquee />
          <Catalog products={products} loading={loading} />
          <SoldShowcase items={sold} />
          <OrderSection />
          <TradeBanner />
          <WhyBuy />
          <AlertsSection />
          <Contact />
        </main>
        <Footer />
        <FloatingWhatsApp />
      </div>
    </SmoothScroll>
  );
}
